import React from 'react';
import { Typography } from '@material-ui/core';

export const progressAndScoreTooltipContent: NonNullable<React.ReactNode> = (
  <>
    <Typography variant="subtitle2" style={{ fontWeight: 700 }}>
      Volg je leerlingen op
    </Typography>
    <Typography variant="subtitle2">
      Het dashboard geeft een helder overzicht van waar je leerlingen staan.
    </Typography>
    <Typography variant="subtitle2">
      Wie wil kan elke score en elk antwoord van de leerling bekijken.
    </Typography>
  </>
);
